'use client'
import { cn } from '@opsynk/utils/tailwind'
import * as React from 'react'
import { type FC } from 'react'

interface MainBoxProps {
  children: React.ReactNode
  className?: React.ComponentProps<'div'>['className']
  noPadding?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const MainBox: FC<MainBoxProps & React.HTMLAttributes<HTMLDivElement>> = ({ children, className, noPadding, onClick, ...props }) => {
  return (
    <div className={cn(`border-base-300 rounded-lg border bg-white ${noPadding ? '' : 'p-4'} `, className)} onClick={onClick} {...props}>
      {children}
    </div>
  )
}

export default MainBox
